/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 *
 * Vue packages => in file app-vue.js
 *
 * This will be load at the top of the page (BACKOFFICE SITE)
 *
 */

// require('./bootstrap');

/**
 * Node packages
 */
// window.domToImage = require('dom-to-image');
// window.jsPDF = require('jspdf').default;
// window.jsQR = require('jsqr');
// window.printjs = require('print-js');
// window.Croppr = require('croppr');
// window.snackbar = require('node-snackbar');


// ✅ Usa import en lugar de require
// import '@fortawesome/fontawesome-free/js/all.js';


import Alpine from 'alpinejs';
import zxcvbn from 'zxcvbn';
import Swal from 'sweetalert2';
import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import select2 from 'select2';
import 'jquery-validation';
import 'bootstrap-datepicker';
import 'bootstrap-switch-button';
import axios from 'axios';
import JSONEditor from 'jsoneditor';
import Ajv from 'ajv';
import localize_es from 'ajv-i18n/localize/es';
import { DateTime } from "luxon";

// ✅ Asigna a `window` si las necesitas globalmente
window.zxcvbn = zxcvbn;
window.Swal = Swal;
window.$ = $;
window.jQuery = $;
window.bootstrap = bootstrap;
window.axios = axios;
window.JSONEditor = JSONEditor;
window.Ajv = Ajv;
window.localize_es = localize_es;
window.DateTime = DateTime;

select2();

window.Alpine = Alpine;
Alpine.start();
